import React, { Fragment, PureComponent } from 'react'
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@material-ui/core'
import {
  Done,
  MoreVert,
  BlockRounded,
  ListRounded
} from '@material-ui/icons'

const menuItems = () => [{ id: 'delBlacklistBooking', label: 'Видалити з ЧС', icon: BlockRounded }]

export class BlacklistBookingsOptionsBase extends PureComponent {
  state = {
    anchorEl: null
  }

  onOptionClick = type => () => {
    const { booking, deleteBlacklistBooking } = this.props

    deleteBlacklistBooking(booking)

    this.handleClose()
  }

  submitEditing = () => {
    const { submitEditing } = this.props

    submitEditing()

    this.handleClose()
  }

  handleOpen = e => this.setState({ anchorEl: e.currentTarget })

  handleClose = () => this.setState({ anchorEl: null })

  renderMenuItem = ({ id, label, icon: Icon }) => (
    <MenuItem key={id} onClick={this.onOptionClick(id)}>

      <ListItemIcon>
        <Icon />
      </ListItemIcon>

      <ListItemText inset primary={label} />

    </MenuItem>
  )

  render() {
    const { anchorEl } = this.state
    const { isEditing } = this.props

    return (
      <Fragment>
        {isEditing
          ? (
            <IconButton onClick={this.submitEditing}>
              <Done />
            </IconButton>
          )
          : (
            <IconButton onClick={this.handleOpen}>
              <MoreVert />
            </IconButton>
          )}
        <Menu
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          anchorEl={anchorEl}
        >
          {menuItems().map(this.renderMenuItem)}
        </Menu>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/BlacklistBookingsOptions/BlacklistBookingsOptions.js